export default function (url) {
  return url?url:''
}